import { render, staticRenderFns } from "./transfer-panel.vue?vue&type=template&id=2ddab8bd&"
import script from "./transfer-panel.vue?vue&type=script&lang=js&"
export * from "./transfer-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddab8bd')) {
      api.createRecord('2ddab8bd', component.options)
    } else {
      api.reload('2ddab8bd', component.options)
    }
    module.hot.accept("./transfer-panel.vue?vue&type=template&id=2ddab8bd&", function () {
      api.rerender('2ddab8bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/transfer/src/transfer-panel.vue"
export default component.exports